<div class="self-inspection-item">
  @if (loading()) {
    <div class="loading-spinner">
      <gc-loading-spinner [pixelSize]="24" />
    </div>
  } @else {
    <div class="item-content">
      <gc-icon
        class="status-icon"
        [iconName]="completed() ? 'circleCheck' : 'triangleExclamation'"
        [color]="completed() ? 'success' : 'critical'"
      />
      <div class="item-text">
        @if (completed() && answer().updatedBy && answer().lastUpdatedAt) {
          <gc-text
            class="completion-details"
            [variant]="'information'"
            [textColor]="answer().isNotCompletable ? 'critical' : 'success'"
          >
            {{ completionMethodKey() | translate }}{{ answer().updatedBy }}
            {{ answer().lastUpdatedAt | date: 'shortDate' }}
          </gc-text>
        }
        @if (completed() && answer().isNotCompletableComment) {
          <gc-text [variant]="'information'">
            {{ answer().isNotCompletableComment }}
          </gc-text>
        }
        <div class="item-description">
          <gc-text class="item-number" [variant]="'paragraphBold'">{{
            item().label
          }}</gc-text>
          <div class="item-copy">
            <div class="item-copy-heading">
              <gc-text [variant]="'paragraph'">{{ item().text }}</gc-text>
              @if (!item().isRequired) {
                <gc-tag>{{ 'buildingPageModal.optional' | translate }}</gc-tag>
              }
            </div>
          </div>
        </div>
        @if (completed() && answer().attachments.length) {
          <gc-button
            [variant]="'plain'"
            [size]="'small'"
            [icon]="'paperclip'"
            [iconPosition]="'left'"
            (clicked)="
              viewAttachments.emit({
                itemId: item().id,
                attachments: answer().attachments,
              })
            "
          >
            {{
              'installationReportV2.selfInspection.showAttachments' | translate
            }}
            ({{ answer().attachments.length }})
          </gc-button>
        } @else if (completed() && answer().files.length) {
          <gc-text [variant]="'information'">
            {{ 'buildingPageModal.uploadedFileCount' | translate
            }}{{ answer().files.length }}
          </gc-text>
        }
      </div>
    </div>

    <div class="item-actions">
      @if (completed()) {
        <gc-button
          [variant]="'secondary'"
          [icon]="'reply'"
          (clicked)="undo.emit()"
        >
          {{
            'installationReportV2.selfInspection.undoSelfInspection' | translate
          }}
        </gc-button>
      } @else if (showNotApplicableForm()) {
        <app-not-applicable-comment
          [notApplicableDescription]="'installationReportV2.selfInspection.notApplicableText'"
          [saveNotApplicableDescription]="'installationReportV2.selfInspection.markAsNonApplicable'"
          (saveNotApplicableComment)="onMarkNotApplicable($event)"
          (cancelAddNotApplicableComment)="closeNotApplicableForm()"
        />
      } @else if (item().action === 'CHECKBOX') {
        <gc-button
          [variant]="'secondary'"
          [icon]="'check'"
          [iconPosition]="'left'"
          (clicked)="markDone.emit()"
        >
          {{ 'installationReportV2.selfInspection.markAsComplete' | translate }}
        </gc-button>
      } @else {
        <gc-button
          [variant]="'secondary'"
          [icon]="'upload'"
          [iconPosition]="'left'"
          (clicked)="fileUpload.click()"
        >
          {{ 'installationReportV2.selfInspection.uploadImage' | translate }}
        </gc-button>
        <input
          #fileUpload
          class="file-input"
          type="file"
          accept=".jpg,.jpeg,.png,video/*"
          multiple
          (change)="onFileSelected($event)"
        />
      }
      @if (
        !completed() && item().canBeNotApplicable && !showNotApplicableForm()
      ) {
        <gc-button
          [variant]="'secondary'"
          [icon]="'triangleExclamation'"
          (clicked)="openNotApplicableForm()"
        >
          {{
            'installationReportV2.selfInspection.markAsNonApplicable'
              | translate
          }}
        </gc-button>
      }
    </div>
  }
</div>
